'use client'
import { useRef } from 'react'

import { useIsomorphicLayoutEffect } from '../../../../core/hook/useIsomorphicLayout'
import { useTranslation } from '../../../context/ConfigContext'
import { Button } from '../../Button/Button'
import { HTMLInputMapId } from '../constants'

import { baiduFetchCityFromGeolocationPosition, baiduInitAutoComplete } from './helpers'
import { BaiduPlace } from './types'

type BaiduAutoCompleteCityProps = {
  onChangePlace: (place: BaiduPlace) => void
}

const BaiduAutoCompleteCity = ({ onChangePlace }: BaiduAutoCompleteCityProps) => {
  const autoCompleteRef = useRef<BMap.Autocomplete | null>(null)
  const t = useTranslation()

  const askUserLocation = async () => {
    try {
      const place = await baiduFetchCityFromGeolocationPosition()
      place && onChangePlace(place)
    } catch (error) {
      alert(t("Vous n'avez pas autorisé la géolocalisation de votre navigateur", {}, false))
    }
  }

  useIsomorphicLayoutEffect(() => {
    autoCompleteRef.current = baiduInitAutoComplete({ onChangePlace })
  }, [onChangePlace])

  return (
    <div className='sellers-page-filter-search'>
      <div className='sellers-page-filter-search-cities'>
        <input
          type='text'
          placeholder={t('storelocator-search-placeholder', {}, false)}
          id={HTMLInputMapId}
          className='map-input-cities pac-target-input'
        />
        <svg
          className='sellers-page-filter-search-cities-icon'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
          width='32'
          height='32'
          viewBox='0 0 32 32'>
          <title>icon-search</title>
          <path d='M6.653 6.653c2.125-2.125 5.008-3.319 8.014-3.319s5.888 1.194 8.014 3.319 3.319 5.008 3.319 8.014c0 2.783-1.023 5.46-2.862 7.529l5.805 5.805-0.943 0.943-5.805-5.805c-2.069 1.838-4.746 2.862-7.529 2.862-3.006 0-5.888-1.194-8.014-3.319s-3.319-5.008-3.319-8.014c0-3.006 1.194-5.888 3.319-8.014zM14.667 4.667c-2.652 0-5.196 1.054-7.071 2.929s-2.929 4.419-2.929 7.071c0 2.652 1.054 5.196 2.929 7.071s4.419 2.929 7.071 2.929c2.652 0 5.196-1.054 7.071-2.929s2.929-4.419 2.929-7.071c0-2.652-1.054-5.196-2.929-7.071s-4.419-2.929-7.071-2.929z'></path>
        </svg>
      </div>
      <Button onClick={askUserLocation} label={t('Locate Nearby', {}, false)} />
    </div>
  )
}

export default BaiduAutoCompleteCity
